var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgTodoList(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 42 42' }, props),
        React.createElement("g", { strokeLinecap: 'round', strokeLinejoin: 'round' },
            React.createElement("path", { d: 'M21.35.25h-.7C9.382.25.25 9.383.25 20.65v.7c0 11.267 9.133 20.4 20.4 20.4h.7c11.267 0 20.4-9.133 20.4-20.4v-.7c0-11.267-9.133-20.4-20.4-20.4zm-.7 1.5h.7c10.439 0 18.9 8.461 18.9 18.9v.7c0 10.439-8.461 18.9-18.9 18.9h-.7c-10.325 0-18.716-8.278-18.897-18.56l-.003-1.04c0-10.439 8.461-18.9 18.9-18.9z' }),
            React.createElement("path", { d: 'M31.909 13.488a.75.75 0 011.165.938l-.07.086L19.55 28.894a2.75 2.75 0 01-3.904.113l-.132-.134-6.066-6.624a.75.75 0 011.025-1.09l.081.077 6.066 6.623a1.25 1.25 0 001.766.078l.069-.068L31.91 13.488z' }))));
}
export default SvgTodoList;
//# sourceMappingURL=TodoList.js.map